export default class PolicySection {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
        // create claim button
       
            case 'policy-section-click-create-claim-button-bilforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'bil skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-campingforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'camping skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-entrepriseforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'entreprise skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-fritidshusforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'fritidshus skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-hundeforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'hunde skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-husforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'hus skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-indboforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'indbo skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-knallertforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'knallert skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-lystfartøjsforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'lystfartøj skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-lønsikringsforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'lønsikring skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-motorcykelforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'motorcykel skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-sundhedsforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-ulykkesforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'ulykke skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-veteranbilforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'veteranbil skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-create-claim-button-øvrige køretøjer-forsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'øvrige køretøjer skadesanmeldelse',
                    'eventAction': 'fs - anmeld skade',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

                // policy details button
            case 'policy-section-click-edit-future-policy':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Se og ret fremtidig forsikring',
                    'eventAction': 'Klik',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-policy-details-button-bilforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Tilgå forsikring',
                    'eventAction': 'vis forsikring - åben',
                    'eventLabel': 'bil',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-policy-details-button-indboforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Tilgå forsikring',
                    'eventAction': 'vis forsikring - åben',
                    'eventLabel': 'indbo',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'policy-section-click-policy-details-button-husforsikring':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Tilgå forsikring',
                    'eventAction': 'vis forsikring - åben',
                    'eventLabel': 'hus',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
                case 'policy-section-click-policy-details-button-ulykkesforsikring':
                    trackingObject = {
                        'event': 'track-event',
                        'eventCategory': 'Tilgå forsikring',
                        'eventAction': 'vis forsikring - åben',
                        'eventLabel': 'ulykke',
                        'eventValue': '0',
                        'eventNoninteraction': true,
                        'data': null
                    };
                    break;
    
        }

        return trackingObject;
    }
}
